module.exports = __webpack_public_path__ + "fonts/TiemposHeadlineWeb-Medium.356d7a1c.woff2";